import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  DocumentCategoryStoreActions,
  DocumentCategoryStoreSelectors,
  DocumentCategoryStoreReducer,
} from './index';
import { DocumentCategoryDto } from '@cradua/data';

@Injectable()
export class DocumentCategoryFacade {
  constructor(
    private store: Store<
      DocumentCategoryStoreReducer.DocumentCategoryPartialState
    >
  ) {}

  documentCategoryRecord$ = this.store.select(
    DocumentCategoryStoreSelectors.getSelected
  );
  documentCategoryRecordError$ = this.store.select(
    DocumentCategoryStoreSelectors.getDocumentCategoryError
  );

  getselected() {
    return this.store.select(DocumentCategoryStoreSelectors.getSelected);
  }

  get isLoadingDocumentCategory() {
    this.store.dispatch(DocumentCategoryStoreActions.loadDocumentCategory());
    return this.store.select(
      DocumentCategoryStoreSelectors.loadingDocumentCategory
    );
  }

  get loadDocumentCategory() {
    this.store.dispatch(DocumentCategoryStoreActions.loadDocumentCategory());
    return this.store.select(
      DocumentCategoryStoreSelectors.getAllDocumentCategory
    );
  }

  addDocumentCategory(newDocumentCategory: DocumentCategoryDto[]) {
    this.store.dispatch(
      DocumentCategoryStoreActions.addDocumentCategory({ newDocumentCategory })
    );
  }

  updateDocumentCategory(updateDocumentCategory: DocumentCategoryDto[]) {
    this.store.dispatch(
      DocumentCategoryStoreActions.updateDocumentCategory({
        updateDocumentCategory,
      })
    );
  }

  removeDocumentCategory(ids: string[]) {
    this.store.dispatch(
      DocumentCategoryStoreActions.removeDocumentCategory({ ids })
    );
  }
}
